import React, { Component } from 'react';
import './skillSetFooter.css';
import CSharp from './../images/techstack/CSharp.svg';
import CSS3 from './../images/techstack/CSS3.png';
import Docker from './../images/techstack/Docker.svg';
import Eth from './../images/techstack/ETH-512.png';
import Git from './../images/techstack/Git.svg';
import HTML from './../images/techstack/HTML_Logo.png';
import Linux from './../images/techstack/Linux.svg';
import PostgreSql from './../images/techstack/Postgresql.svg';
import Python from './../images/techstack/Python.svg';
import ReactIcon from './../images/techstack/React.svg';
import Redis from './../images/techstack/Redis.svg';
import TypeScript from './../images/techstack/TypeScript.png';
import Azure from './../images/techstack/Azure.png';

const allIcons = [
    {"path": CSharp, "Title": "C#"}, 
    {"path": ReactIcon , "Title": "React"}, 
    {"path": PostgreSql, "Title": "PostgreSQL"}, 
    {"path": Python, "Title": "Python"},
    {"path": Azure, "Title": "Azure"}, 
    {"path": Docker, "Title": "Docker"}, 
    {"path": Eth, "Title": "Ethereum"}, 
    {"path": Git, "Title": "Git VCS"}, 
    {"path": TypeScript, "Title": "TypeScript"},
    {"path": HTML, "Title": "HTML 5"}, 
    {"path": CSS3, "Title": "CSS 3"}, 
    {"path": Linux, "Title": "Linux"}, 
    {"path": Redis, "Title": "Redis"}
];

export default class SkillSetFooter extends Component<any, any>{

    private currentComponent: React.RefObject<HTMLInputElement>;

    constructor(props: any){
        super(props);
        this.currentComponent = React.createRef();
        this.state = {
            componentWidth: 0,
            scrollLength: 0
        }
    }

    componentDidMount () {
        let comp = this;
        setTimeout(
            function()
            {
                let compWidth = (comp.currentComponent.current?.scrollWidth || 0 ) - (comp.currentComponent.current?.offsetWidth || 0 );
                comp.setState({componentWidth: compWidth}, () => {comp.computeNextScrollLength();});
            }, 5000);
    }

    computeNextScrollLength() {
        let compWidth = this.state.componentWidth;
        let currentScrollLength =  this.state.scrollLength;
        currentScrollLength += compWidth/5;
        if(currentScrollLength > compWidth)
        currentScrollLength = 0;
        currentScrollLength = Number((currentScrollLength).toFixed(1)); 
        
        let comp = this;
        this.setState(
            {scrollLength: currentScrollLength, componentWidth: compWidth},
            () => {
                setTimeout(function(){comp.computeNextScrollLength()}, 2000)
            });
    }

    render(){

        return (
            <div className="SkillSetContainer h-100 w-100">
                <div ref={this.currentComponent}  className="SkillSetScroll d-flex align-items-center h-100" style={{marginLeft: 0 - this.state.scrollLength}} id="scrollbar">
                    {
                        allIcons.map((element, indx) => {
                            return(
                                <img src={element.path} key={indx} className="SkillIcon" alt="Not Found" data-toggle="tooltip" data-placement="top" title={element.Title} data-delay={0} />
                            )})
                    }
                </div>
            </div>
        );
    }
}